import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useFamilyData } from "@/hooks/use_family_data";
import { LedgerProvider } from "@/hooks/use_ledger";
export function FamilyScope({ children }: { children: ReactNode }): React.JSX.Element {
  const data = useFamilyData();
  // The first local read must settle before deciding membership is absent.
  if (data === undefined) return <div className="min-h-dvh bg-bg" />;
  if (data?.familyError) return <p role="alert" className="min-h-dvh bg-bg px-phi-1 pt-safe">{data.familyError}</p>;
  if (!data?.ledger) return <Navigate to="/home" replace />;
  if (!data.profile) return <p role="status" className="min-h-dvh bg-bg px-phi-1 pt-safe">Loading family…</p>;
  return <LedgerProvider ledger={data.ledger}>{children}</LedgerProvider>;
}
